import { Box, Tooltip } from "@mui/material";
import { componentID } from "core/services/componentService/component-service-base";
import React from "react";
import { NodeProps } from "reactflow";
import { NodeCategory, NodeContent, NodeHandle, NodeStats } from "./node.commons";
import { getNodeContainerStyles } from "./node.styles";
import { useAppSelector } from "src/stores/redux/hooks";
import { getSelectedNode } from "../helpers/selectors";

interface FlowNodeData {
    label: string;
    type?: string;
    componentType?: string;
    componentId: componentID;
    metaObject?: any;
    stats?: any;
}

const FlowNode = ({ data, sourcePosition, targetPosition, id }: NodeProps<FlowNodeData>) => {
    const selectedNode = useAppSelector(getSelectedNode);
    const selected = selectedNode?.id === id;
    return (
        <Tooltip title="Click to view flow components" arrow placement="top">
            <Box
                sx={{
                    ...getNodeContainerStyles(selected || false, false, sourcePosition),
                    borderRadius: "30px"
                }}
                data-test-id={`node_container_${data.label}`}
            >
                <NodeStats stats={data.stats} />
                <NodeContent data={data} hideDescription={true} />
                <NodeHandle sourcePosition={sourcePosition} targetPosition={targetPosition} nodeId={id} />
            </Box>
        </Tooltip>
    );
};

export default FlowNode;
